<template>
    <div>
        <nav id="navBar">
            <button id="navBarToggle" @click="navBarClick"></button>
            <ul  v-scroll-spy-active v-scroll-spy-link>
                <li id="logo">
                    <a id="forte" href="/">Forte</a>
                </li>
                <li id="navOurForte">
                    <!-- <a v-scroll-to="{
                        el: '#page_ourForte'
                    }">Our Forte</a> -->
                    <a>Our Forte</a>
                    
                </li>
                <li id="navExperience">
                    <!-- <a v-scroll-to="{
                        el: '#page_experience'
                    }">Experience</a> -->
                    <a>Experience</a>
                </li>
                <!-- <li>
                    <a v-scroll-to="{
                        el: '#page_experience'
                    }">Experience 2</a>
                </li> -->
                <li id="navAchievements">
                    <!-- <a v-scroll-to="{
                        el: '#page_achievements'
                    }">Achievements</a> -->
                    <a>Achievements</a>
                </li>
                <li id="navGlory">
                    <!-- <a v-scroll-to="{
                        el: '#page_glory'
                    }">Glory</a> -->
                    <a>Glory</a>
                </li>
                <li id="navGallery">
                    <!-- <a v-scroll-to="{
                        el: '#page_gallery'
                    }">Gallery</a> -->
                    <a>Gallery</a>
                </li>
                <li id="navContact">
                    <!-- <a v-scroll-to="{
                        el: '#page_contact'
                    }">Contact</a> -->
                    <a>Contact</a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    name: 'AppHeader',
    prop: [ 'navBarToggle' ],
    methods: {
        navBarClick() {
            this.$emit('navBarToggle');
        }
    }
}
</script>

<style lang="less" scoped>

</style>